import {Box} from "@mui/material";
import OriginalCalendar from "../OriginalCalendar.jsx";
import {Helmet} from "react-helmet";
import {OriginalCalendarURI} from "../Button/OriginalCalendarButton.jsx";

import {Crumbs} from "../Crumbs.jsx";
import { LatestAnnouncement } from "./Announcement.jsx";
import ReactGA from "react-ga4";

const title = "Pro Austin 2-Step Calendar";
const desc = "6 weeks of easy scrollin, boot scootin', 2-steppin' events. Great for dancers that already know all the venues and bands."

export const OriginalCalendarPage = () => {

     const handleClick = () => {
            ReactGA.event({
                category: "link",
                action: "click",
                label: "waltz"
            });
            window.open("https://www.eventbrite.com/e/big-beautiful-waltz-dance-workshop-tickets-1962723143758?aff=austin2step", "_blank");
        }

    return <Box>
        <Helmet>
            <meta charSet="utf-8"/>
            <meta property="og:description" content={desc}/>
            <meta property="twitter:title" content={title}/>
            <meta property="twitter:description" content={desc}/>
            <title>{title}</title>
            <meta property="description" content={desc} />
            <link rel="canonical" href={OriginalCalendarURI}/>
        </Helmet>
        {/*<PatreonAlert />*/}
        <Crumbs crumbs={[
        
            { title: "Where to Dance", href: "/where-to-dance" },
            { title: "Pro Calendar" }
        ]} />
        <LatestAnnouncement /> 
        {/* <Box style={{flex: "row", alignItems: "center", justifyContent: "center", display: "flex", gap: "8px"}}>
                <a target="blank" onClick={handleClick} href="#"><img src="/WALTZ.gif" alt="Waltz" width={300} /></a>
                <SponsorDialog />
            </Box> */}
        <OriginalCalendar showFilters={true}/>
        
    </Box>
}